import React, { useContext, useEffect, useState, useTransition } from "react";
import "./RegrasRPA.scss";
import { useNavigate } from "react-router-dom";
import GlobalContext from "@context/GlobalContext";
import useLoading from "@hooks/useLoading";
import Grid from "@components/grid/Grid";
import EndPointServices from "@services/ApiServices";
import mappingColumn from "@components/grid/mappingColumn";
import Button from "@components/button/Button";
import MessageServices from "@services/MessageServices";
import CheckBox from "@components/checkbox/CheckBox";

const RegrasRPA = () => {
  const [isPending, startTransition] = useTransition();
  const [isPendingA, startTransitionA] = useTransition();
  const [isPendingB, startTransitionB] = useTransition();
  useLoading(isPending);

  useEffect(() => {
    handleConsultaRegra();
    handleConsultaEmpresa(null);
  }, []);

  //Variaveis Padrões
  const [state, dispatch] = useContext(GlobalContext);
  const navigate = useNavigate();

  //Regras
  const [dadosGridRegra, setDadosGridRegra] = useState([]);
  const [idRegra, setIdRegra] = useState(null);

  //Empresas
  const [dadosEmpresa, setDadosEmpresa] = useState([]);
  const [idsEmpresa, setIdsEmpresa] = useState([]);

  //checkbox
  const [check, setCheck] = useState(false);

  useEffect(() => {
    setIdsEmpresa([]);
  }, [check]);

  function handleConsultaRegra() {
    startTransitionA(async () => {
      let data = {
        id_usuario_guid: state.dadosusuario?.id_usuario_guid,
        id_usuario: state.dadosusuario?.id_usuario,
      };

      var retornoapi = await EndPointServices.Rpa_ConsultaRegra(data);
      if (retornoapi?.Success) {
        setDadosGridRegra(retornoapi.BaseReturn.LstClasse);
      }
    });
  }
  function handleConsultaRegraDetalhada(id_regra) {
    startTransition(async () => {
      let data = {
        id_usuario_guid: state.dadosusuario?.id_usuario_guid,
        id_usuario: state.dadosusuario?.id_usuario,
        id_regra: id_regra,
      };

      var retornoapi = await EndPointServices.Rpa_ConsultaRegraDetalhada(data);
      if (retornoapi?.Success) {
        dispatch({
          type: "SET_REGRASELECIONADA",
          payload: retornoapi?.BaseReturn?.LstClasse,
        });
        navigate("/RPA/Cadastro/Regras");
      }
    });
  }
  function handleConsultaEmpresa(id_regra) {
    startTransitionB(async () => {
      let data = {
        id_usuario_guid: state.dadosusuario?.id_usuario_guid,
        id_usuario: state.dadosusuario?.id_usuario,
        id_regra: id_regra,
      };
      var retornoapi = await EndPointServices.Rpa_ConsultaEmpresaRegraVinculada(
        data,
      );
      if (retornoapi?.Success) {
        setDadosEmpresa(retornoapi.BaseReturn.LstClasse);
      }
    });
  }
  function handleVincularRegra() {
    let dados = {
      empresa: idsEmpresa,
      id_regra: idRegra,
    };

    startTransition(async () => {
      let data = {
        id_usuario_guid: state.dadosusuario?.id_usuario_guid,
        id_usuario: state.dadosusuario?.id_usuario,
        json: dados,
      };

      var retornoapi = await EndPointServices.Rpa_AdicionarRegraVinculada(data);
      if (retornoapi?.Success) {
        MessageServices.ShowSuccess("Empresas vinculadas a regra com sucesso!");
        handleConsultaEmpresa(null);
        handleConsultaRegra();
        setCheck(false);
      }
    });
  }
  function handleDeletaRegra(idRegra) {
    startTransition(async () => {
      let data = {
        id_usuario_guid: state.dadosusuario?.id_usuario_guid,
        id_usuario: state.dadosusuario?.id_usuario,
        id_regra: idRegra,
      };

      var retornoapi = await EndPointServices.Rpa_DeletaRegra(data);
      if (retornoapi?.Success) {
        MessageServices.ShowSuccess("Regra deletada com sucesso.");
        handleConsultaEmpresa(null);
        handleConsultaRegra();
        setCheck(false);
      }
    });
  }

  return (
    <div className="regrasrpa row">
      <div className="d-lg-flex align-items-center ">
        <div className="col-lg-6 col-12 passo-1">
          <CheckBox
            checked={check}
            onChange={(e) => setCheck(e.target.checked)}
            title="Selecione esta opção para associar empresas às regras."
          />
        </div>
        <div className="col-lg-6 col-12 d-flex justify-content-center justify-content-lg-end">
          <Button
            nome="Nova Regra"
            icon="<i class='fa-solid fa-plus'></i>"
            theme="2"
            onClick={() => {
              navigate("/RPA/Cadastro/Regras");
            }}
          />
        </div>
      </div>
      <div className="d-flex justify-content-lg-start justify-content-center">
        <Button
          nome="Fazer vinculação"
          icon="<i class='fa-solid fa-link-horizontal'></i>"
          className="passo-2 btn-vinculacao"
          theme="2"
          disabled={!(idsEmpresa.length > 0 && idRegra && check)}
          onClick={() => {
            handleVincularRegra();
          }}
        />
      </div>
      <div className="col-12 col-lg-6 mt-5">
        <Grid
          dadosGrid={dadosGridRegra}
          columns={mappingColumn.getRPA_Regras(
            dadosGridRegra,
            handleDeletaRegra,
            handleConsultaRegraDetalhada,
          )}
          {...(dadosGridRegra?.length > 0 && {
            pageVisible: true,
          })}
          selection={{
            allowSelectAll: false,
            mode: "multiple",
            showCheckBoxesMode: "always",
          }}
          iconTitle="<i class='fa-solid fa-scale-balanced'></i>"
          title="Suas Regras"
          Memo={false}
          useLoading={isPendingA}
          pagingStaticSize="5"
          onSelectionChanged={(e) => {
            if (e.selectedRowKeys.length > 1) {
              e.component.selectRows([e.selectedRowKeys[1]]);
              e.component.deselectRows([e.selectedRowKeys[0]]);
            }

            setIdRegra(e.currentSelectedRowKeys[0]?.id_regra);
            if (e.currentSelectedRowKeys[0] && !check) {
              handleConsultaEmpresa(e.currentSelectedRowKeys[0]?.id_regra);
            }
            if (!e.currentSelectedRowKeys[0]) {
              handleConsultaEmpresa(null);
            }
          }}
        />
      </div>
      <div className="col-12 col-lg-6 mt-5">
        <Grid
          dadosGrid={dadosEmpresa}
          columns={mappingColumn.getRPA_Empresas(dadosEmpresa)}
          {...(dadosEmpresa?.length > 0 && {
            pageVisible: true,
          })}
          {...(check && {
            selection: {
              allowSelectAll: true,
              mode: "multiple",
              showCheckBoxesMode: "always",
            },
          })}
          iconTitle="<i class='fa-solid fa-users'></i>"
          title="Empresas Relacionadas"
          Memo={false}
          useLoading={isPendingB}
          pagingStaticSize="5"
          onSelectionChanged={(e) => {
            setIdsEmpresa(e.selectedRowKeys);
          }}
          noDataText="Sem dados, faça a vinculação dessa regra."
        />
      </div>
    </div>
  );
};

export default RegrasRPA;
